export default "__VITE_ASSET__3dD4eyLD__"